/**
 * Opening the report form from anywhere (UI round of 2026-11-02): the avatar
 * menu, the Support page's tiles, "Add what you saw", an alert's ⋯. The form is
 * mounted once in the shell (`ReportProblemHost`); this is the one way in.
 */
export type ReportCategory = 'robot' | 'lift_door' | 'app' | 'other';

export interface ReportPrefill {
  readonly category?: ReportCategory;
  /** The robot, lift or door it is about, by name. */
  readonly subject?: string;
  /** Starts the free text: what they were looking at. */
  readonly note?: string;
  /** Become confirmed links on the ticket. */
  readonly issueId?: string;
  readonly alertId?: string;
}

export const REPORT_PROBLEM_EVENT = 'nx:report-problem';

export function openReportProblem(prefill: ReportPrefill = {}): void {
  window.dispatchEvent(new CustomEvent<ReportPrefill>(REPORT_PROBLEM_EVENT, { detail: prefill }));
}
